<div class="document-list">

  <ul class="items-list" #list>
    <li class="item" *ngFor="let item of documents; index as i;" (click)="onSelectedItem(i)">
      <a class="item-text">{{item.title | stringTranslate}}</a>
    </li>
  </ul>

</div>
